var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u94B1\\u5305\\u8D26\\u6237\\u6210\\u529F\\u63A5\\u5165\\u5907\\u4EFD",
    transform: "translate(-688.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD",
    transform: "translate(480.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(31.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(177.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1,8 L6.9,8 C3.4,8 2,9.4 2,12.9 L2,17.1 C2,20.6 3.4,22 6.9,22 L11.1,22 C14.6,22 16,20.6 16,17.1 L16,12.9 C16,9.4 14.6,8 11.1,8 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#0057FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,11.1 L22,6.9 C22,3.4 20.6,2 17.1,2 L12.9,2 C9.4,2 8,3.4 8,6.9 L8,8 L11.1,8 C14.6,8 16,9.4 16,12.9 L16,16 L17.1,16 C20.6,16 22,14.6 22,11.1 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#0057FF",
    strokeWidth: 1.5,
    opacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    opacity: 0,
    points: "0 24 24 24 24 0 0 0"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.635f7da05ec4d1da78a84be790503cd0.svg";
export { ForwardRef as ReactComponent };